@if (breadcrumbs().length > 1) {
  <div class="app-toolbar py-3 py-lg-6">
    <div class="container-xxl d-flex flex-stack px-0">
      <div
        class="page-title d-flex flex-column justify-content-center flex-wrap me-3"
      >
        <h1
          class="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0"
        >
          {{ breadcrumbs()[breadcrumbs().length - 1].label | transloco }}
        </h1>
        <ul
          class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1"
        >
          @for (
            breadcrumb of breadcrumbs();
            track breadcrumb;
            let last = $last
          ) {
            <li
              class="breadcrumb-item gap-2"
              [ngClass]="{ 'text-muted': !last }"
            >
              @if (breadcrumb.url && !last) {
                <a
                  [routerLink]="[breadcrumb.url]"
                  class="text-muted text-hover-primary"
                  >{{ breadcrumb.label | transloco }}</a
                >
              } @else {
                <span>{{ breadcrumb.label | transloco }}</span>
              }
              @if (!last) {
                <span class="bullet bg-gray-500 w-5px h-2px"></span>
              }
            </li>
          }
        </ul>
      </div>
      @if (breadcrumbs()[breadcrumbs().length - 1].goBack) {
        <a
          class="btn btn-sm fw-bold btn-primary whitespace-nowrap"
          coreGoBack
          >{{ breadcrumbs()[breadcrumbs().length - 1].goBack | transloco }}</a
        >
      }
      @if (breadcrumbs()[breadcrumbs().length - 1].buttonLabel) {
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <button
            [disabled]="breadcrumbs()[breadcrumbs().length - 1].disabled"
            [routerLink]="[
              breadcrumbs()[breadcrumbs().length - 1].url,
              PAGE_ROUTES()['ADD'],
            ]"
            class="btn btn-sm fw-bold btn-primary"
          >
            {{
              breadcrumbs()[breadcrumbs().length - 1].buttonLabel | transloco
            }}
          </button>
        </div>
      }
      @if (breadcrumbs()[breadcrumbs().length - 1].showList) {
        <a
          [routerLink]="[
            '/' +
              getFirstSegment(
                breadcrumbs()[breadcrumbs().length - 1].url ?? ''
              ),
          ]"
          class="btn btn-sm fw-bold btn-primary"
          >{{ breadcrumbs()[breadcrumbs().length - 1].showList | transloco }}</a
        >
      }
    </div>
  </div>
}
